'use strict';

function CnQuestionnaireChoicesController() {
  var vm = this;

  vm.$onInit = $onInit;

  function $onInit() {
    vm.error = vm.error === true || false;
    vm.locked = vm.locked === true || false;
  }
}

module.exports = CnQuestionnaireChoicesController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-questionnaire-choices/cn-questionnaire-choices.controller.js
 ** module id = 119
 ** module chunks = 0
 **/